import * as DM from "@radix-ui/react-dropdown-menu";
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from "react";
import { cn } from "@/lib/utils";

export const DropdownMenu = DM.Root;
export const DropdownMenuTrigger = DM.Trigger;

export const DropdownMenuContent = forwardRef<
  ElementRef<typeof DM.Content>,
  ComponentPropsWithoutRef<typeof DM.Content>
>(function DropdownMenuContent({ className, sideOffset = 6, ...props }, ref) {
  return (
    <DM.Portal>
      <DM.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "z-50 min-w-[12rem] rounded-md border border-zinc-200 bg-brand-white p-1 shadow-lg",
          "focus:outline-none",
          className
        )}
        {...props}
      />
    </DM.Portal>
  );
});

export const DropdownMenuItem = forwardRef<
  ElementRef<typeof DM.Item>,
  ComponentPropsWithoutRef<typeof DM.Item>
>(function DropdownMenuItem({ className, ...props }, ref) {
  return (
    <DM.Item
      ref={ref}
      className={cn(
        "cursor-pointer rounded px-2 py-1.5 text-sm text-brand-black",
        "data-[highlighted]:bg-zinc-100 data-[disabled]:opacity-50 data-[disabled]:pointer-events-none",
        "focus-visible:outline-none",
        className
      )}
      {...props}
    />
  );
});

export const DropdownMenuSeparator = forwardRef<
  ElementRef<typeof DM.Separator>,
  ComponentPropsWithoutRef<typeof DM.Separator>
>(function DropdownMenuSeparator({ className, ...props }, ref) {
  return <DM.Separator ref={ref} className={cn("my-1 h-px bg-zinc-200", className)} {...props} />;
});

export const DropdownMenuLabel = forwardRef<
  ElementRef<typeof DM.Label>,
  ComponentPropsWithoutRef<typeof DM.Label>
>(function DropdownMenuLabel({ className, ...props }, ref) {
  return (
    <DM.Label
      ref={ref}
      className={cn("px-2 py-1 text-xs uppercase tracking-wide text-zinc-500", className)}
      {...props}
    />
  );
});
